<template>
  <div class="relative">
    <div
      class="black-friday-double relative text-white"
      v-if="blackFriday"
      :content="tooltip"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <span
        v-if="blackFriday"
        class="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform text-[12px] font-bold uppercase leading-tight"
      >
        Black Friday
      </span>
      <span
        v-else
        class="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform font-bold uppercase leading-tight"
      >
        {{ discount }}% off
      </span>
    </div>
    <div
      class="relative text-white"
      :class="blackFriday ? 'black-friday' : 'badge'"
      :content="tooltip"
      v-tippy="{ arrow: true, theme: 'green' }"
    >
      <span
        v-if="blackFriday"
        class="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform text-[12px] font-bold uppercase leading-tight"
      >
        {{ text }}
      </span>
      <span
        v-else
        class="absolute top-1/2 left-1/2 z-10 -translate-x-1/2 -translate-y-1/2 transform font-bold uppercase leading-tight"
      >
        {{ discount }}% off
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tooltip: {
      type: String,
    },
    discount: {
      type: [Number, String],
    },
    blackFriday: {
      type: Boolean,
    },
    text: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  @apply bg-ontick-red-600 h-12 w-12;
  // position: relative;
  text-align: center;
}
.badge:before,
.badge:after {
  @apply bg-ontick-red-600 h-12 w-12;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
}
.badge:before {
  transform: rotate(30deg);
}
.badge:after {
  transform: rotate(60deg);
}

.black-friday {
  @apply bg-ontick-carbon-500 h-12 w-12;
  // position: relative;
  text-align: center;
}
.black-friday:before,
.black-friday:after {
  @apply bg-ontick-carbon-500 h-12 w-12;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
}
.black-friday:before {
  transform: rotate(30deg);
}
.black-friday:after {
  transform: rotate(60deg);
}

.black-friday-double {
  @apply absolute h-12 w-12 scale-110 transform bg-white;
  // position: relative;
  text-align: center;
}
.black-friday-double:before,
.black-friday-double:after {
  @apply h-12 w-12 bg-white;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
}
.black-friday-double:before {
  transform: rotate(30deg);
}
.black-friday-double:after {
  transform: rotate(60deg);
}
</style>
